import React from 'react';
import { Typography, Card, CardContent, Container, List, ListItem } from '@mui/material';

const Programs = () => {
  return (
    <Container sx={{ py: 15 }}>
      <Card sx={{ mb: 6, p: 3 }}>
        <CardContent>
          <Typography variant="h4" gutterBottom align="center">
            Elite Junior Team
          </Typography>

          <Typography variant="body1" paragraph>
            The Great Lakes Golf Academy Elite Junior Team runs from May to August and is built for young athletes ready to elevate every aspect of their game. Designed as a one-stop shop for complete player development, this program mirrors the structure, expectations, and competitive environment of a collegiate golf team.
          </Typography>

          <Typography variant="body1" paragraph>
            At the heart of the Elite Junior Team is a simple belief: iron sharpens iron. When talented athletes train together in a fun, competitive, and supportive environment, development accelerates. Players learn to thrive under pressure, embrace competition, and build the habits that define long-term success.
          </Typography>

          <Typography variant="body1" paragraph>
            This program places competitive junior golfers in a team environment that provides every tool required for competitive golf: coaching, fitness, mental training, structured practice, and on-course application. Juniors learn accountability, resilience, time management, and how to push themselves alongside peers who share their goals.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            Program Highlights
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Comprehensive Training Experience
          </Typography>
          <List dense>
            <ListItem>40 hours of structured practice sessions and lessons focused on technical skill, scoring ability, short game mastery, and on-course decision making</ListItem>
            <ListItem>Stat tracking and measurable development in all areas of the game</ListItem>
            <ListItem>4 rounds of golf with a performance coach to develop course management skills</ListItem>
            <ListItem>Program schedule aligned with the Ontario junior tournament schedule for seamless seasonal preparation</ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Athletic Development & Mental Performance
          </Typography>
          <List dense>
            <ListItem>5 TPI-led workouts to build mobility, strength, and speed</ListItem>
            <ListItem>Personalized fitness and nutrition plans</ListItem>
            <ListItem>Sport psychology sessions to develop confidence and competitive resilience</ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Equipment & Support
          </Typography>
          <List dense>
            <ListItem>Coaching from certified teachers with OUA, NCAA Division I, and Pro Tour experience</ListItem>
            <ListItem>Launch monitor data</ListItem>
            <ListItem>Swing video analysis platform</ListItem>
            <ListItem>Exclusive club fitting and equipment discounts through trusted partners</ListItem>
            <ListItem>Team apparel</ListItem>
          </List>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Ready to take the next step?
          </Typography>
          <Typography variant="body1">
            To apply for this program, please contact <strong>jc.glgolf@gmail.com</strong>.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Programs;